
















import { Vue, Component } from "vue-property-decorator";
import ContractForm from "@/components/contract/ContractForm.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningGroupForm from "@/components/learning-group/LearningGroupForm.vue";
import { learningGroupsApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: { LearningGroupForm, CPage, ContractForm }
})
export default class ContractNew extends Vue {
  isLoading: boolean = false;
  get breadcrumbs() {
    return [
      {
        to: { name: "learningGroupList" },
        label: this.$tc(this.$translate.TrainingGroups)
      },
      {
        label: this.$tc(this.$translate.Add)
      }
    ];
  }

  createGroup(form: any) {
    this.isLoading = true;
    learningGroupsApi.Group.createLearningGroup(form)
      .then(res => {
        this.$router.push({
          name: "learningGroup",
          params: { id: res.data.id }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })

      .finally(() => {
        this.isLoading = false;
      });
  }
  cancel() {
    this.$router.push({ name: "learningGroupList" });
  }
}
